/**
 * Custom Product Slider - Japanese Layout
 * Handles thumbnail navigation and image switching
 */

class CustomProductSlider {
  constructor() {
    this.thumbnails = document.querySelectorAll('.product-thumbnail-item');
    this.featuredImage = document.getElementById('featured-image');
    this.currentIndex = 0;

    this.init();
  }

  init() {
    if (!this.featuredImage || this.thumbnails.length === 0) {
      return;
    }

    this.autoScrollInterval = null;
    this.autoScrollDelay = 3000; // 3 seconds between slides

    this.preloadAndStackImages();
    this.bindEvents();
    this.addKeyboardNavigation();
    this.addTouchSwipe();
    this.startAutoScroll();
  }

  preloadAndStackImages() {
    const sliderMain = document.querySelector('.product-slider-main');
    if (!sliderMain) return;

    // Set container to relative positioning for stacking
    sliderMain.style.position = 'relative';
    sliderMain.style.overflow = 'hidden';

    // Get the dimensions from the featured image to maintain aspect ratio
    const firstImageUrl = this.thumbnails[0].getAttribute('data-image-url');

    // Create stacked images for all thumbnails
    this.slideImages = [];
    this.thumbnails.forEach((thumbnail, index) => {
      const img = document.createElement('img');
      img.src = thumbnail.getAttribute('data-image-url');
      img.alt = this.featuredImage.alt || '';
      img.style.cssText = `
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: contain;
        opacity: ${index === 0 ? '1' : '0'};
        transition: opacity 0.3s ease;
        border-radius: 8px;
      `;
      sliderMain.appendChild(img);
      this.slideImages.push(img);
    });

    // Keep the original featured image as the first visible one, then hide it
    // Use it to set the container height
    this.featuredImage.style.visibility = 'hidden';
    this.featuredImage.style.position = 'relative';
    this.featuredImage.style.display = 'block';
    this.featuredImage.style.width = '100%';
  }

  bindEvents() {
    this.thumbnails.forEach((thumbnail, index) => {
      thumbnail.addEventListener('click', (e) => {
        e.preventDefault();
        this.switchImage(index);
        this.resetAutoScroll();
      });
    });

    // Pause auto-scroll on hover, resume on mouse leave
    const sliderSection = document.querySelector('.product-slider-section');
    if (sliderSection) {
      sliderSection.addEventListener('mouseenter', () => this.stopAutoScroll());
      sliderSection.addEventListener('mouseleave', () => this.startAutoScroll());
    }
  }

  switchImage(index) {
    // Remove active class from all thumbnails
    this.thumbnails.forEach(t => t.classList.remove('active'));

    // Add active class to selected thumbnail
    this.thumbnails[index].classList.add('active');

    // Crossfade between preloaded stacked images
    if (this.slideImages) {
      this.slideImages.forEach((img, i) => {
        img.style.opacity = i === index ? '1' : '0';
      });
    }

    this.currentIndex = index;
  }

  addTouchSwipe() {
    const sliderMain = document.querySelector('.product-slider-main');
    if (!sliderMain) return;

    let touchStartX = 0;
    let touchStartY = 0;
    let touchEndX = 0;
    let touchEndY = 0;
    const minSwipeDistance = 50;

    sliderMain.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
      touchStartY = e.changedTouches[0].screenY;
      this.stopAutoScroll();
    }, { passive: true });

    sliderMain.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].screenX;
      touchEndY = e.changedTouches[0].screenY;

      const diffX = touchStartX - touchEndX;
      const diffY = touchStartY - touchEndY;

      // Only trigger if horizontal swipe is greater than vertical (not a scroll)
      if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > minSwipeDistance) {
        if (diffX > 0) {
          this.navigateNext();
        } else {
          this.navigatePrevious();
        }
      }

      this.startAutoScroll();
    }, { passive: true });
  }

  addKeyboardNavigation() {
    document.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') {
        this.navigatePrevious();
      } else if (e.key === 'ArrowRight') {
        this.navigateNext();
      }
    });
  }

  navigatePrevious() {
    const newIndex = this.currentIndex > 0 ? this.currentIndex - 1 : this.thumbnails.length - 1;
    this.switchImage(newIndex);
  }

  navigateNext() {
    const newIndex = this.currentIndex < this.thumbnails.length - 1 ? this.currentIndex + 1 : 0;
    this.switchImage(newIndex);
  }

  startAutoScroll() {
    if (this.thumbnails.length <= 1) return;
    this.stopAutoScroll();
    this.autoScrollInterval = setInterval(() => {
      this.navigateNext();
    }, this.autoScrollDelay);
  }

  stopAutoScroll() {
    if (this.autoScrollInterval) {
      clearInterval(this.autoScrollInterval);
      this.autoScrollInterval = null;
    }
  }

  resetAutoScroll() {
    this.stopAutoScroll();
    this.startAutoScroll();
  }
}

// Initialize slider when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  new CustomProductSlider();

});

// Handle variant changes
if (document.getElementById('variant-selector')) {
  document.getElementById('variant-selector').addEventListener('change', function(e) {
    const selectedVariantId = e.target.value;
    const form = document.getElementById('custom-product-form');

    // Update hidden input
    const hiddenInput = form.querySelector('input[name="id"]');
    if (hiddenInput) {
      hiddenInput.value = selectedVariantId;
    }

    // Update price if needed
    const selectedOption = e.target.selectedOptions[0];
    const priceText = selectedOption.textContent.split(' - ')[1];
    const priceDisplay = document.querySelector('.product-price');
    if (priceDisplay && priceText) {
      priceDisplay.textContent = priceText;
    }
  });
}

// Add to cart form handling
const productForm = document.getElementById('custom-product-form');
if (productForm) {
  productForm.addEventListener('submit', function(e) {
    e.preventDefault();

    const formData = new FormData(this);
    const submitButton = this.querySelector('button[type="submit"]');

    // Disable button and show loading state
    submitButton.disabled = true;
    const originalText = submitButton.textContent;
    submitButton.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    })
    .then(response => response.json())
    .then(data => {
      // Re-enable button
      submitButton.disabled = false;
      submitButton.textContent = originalText;

      // Optional: Redirect to cart or update cart count
      // window.location.href = '/cart';
    })
    .catch(error => {
      console.error('Error:', error);
      alert('Error adding product to cart. Please try again.');

      // Re-enable button
      submitButton.disabled = false;
      submitButton.textContent = originalText;
    });
  });
}
